import { defineComponent, h, useAttrs } from 'vue'
import { VBtn } from 'vuetify/components'

const LEGACY_COLOR_VALUES = {
  'blue darken-1': '#1e88e5',
  orange: '#ff9800',
  secondary: 'rgb(var(--v-theme-secondary))'
}

function hasBooleanishAttr(value) {
  return value === '' || value === true || value === 'true'
}

function resolveButtonVariant(attrs) {
  if (attrs.variant != null) return attrs.variant
  if (hasBooleanishAttr(attrs.raised)) return 'elevated'
  if (hasBooleanishAttr(attrs.text)) return 'text'
  if (hasBooleanishAttr(attrs.outlined)) return 'outlined'
  if (hasBooleanishAttr(attrs.depressed)) return 'flat'
  if (hasBooleanishAttr(attrs.plain)) return 'plain'
  if (attrs.icon != null) return 'text'
  return 'elevated'
}

function resolveButtonSize(attrs) {
  if (attrs.size != null) return attrs.size
  if (hasBooleanishAttr(attrs['x-small']) || hasBooleanishAttr(attrs.xSmall)) {
    return 'x-small'
  }
  if (hasBooleanishAttr(attrs.small)) return 'small'
  if (hasBooleanishAttr(attrs.large)) return 'large'
  if (hasBooleanishAttr(attrs['x-large']) || hasBooleanishAttr(attrs.xLarge)) {
    return 'x-large'
  }
  return undefined
}

function removeLegacyAttrs(attrs) {
  const normalized = { ...attrs }
  const legacyColor = resolveLegacyColor(attrs.color, attrs)

  if (legacyColor) {
    normalized.class = attrs.class
    normalized.style = [
      attrs.style,
      legacyColor.textOnly ? { color: legacyColor.value } : null
    ]
    delete normalized.color
  }

  delete normalized.text
  delete normalized.outlined
  delete normalized.depressed
  delete normalized.plain
  delete normalized.raised
  delete normalized.dark
  delete normalized.light
  delete normalized.small
  delete normalized.large
  delete normalized['x-small']
  delete normalized.xSmall
  delete normalized['x-large']
  delete normalized.xLarge
  return normalized
}

function resolveLegacyColor(color, attrs = {}) {
  if (typeof color !== 'string') return undefined

  const value = LEGACY_COLOR_VALUES[color]
  if (!value) return undefined

  if (attrs.icon != null) {
    return {
      textOnly: true,
      value
    }
  }

  if (color !== 'blue darken-1') return undefined

  return {
    textOnly: true,
    value
  }
}

export default defineComponent({
  name: 'VBtnCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['click'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    return () => {
      const normalizedAttrs = removeLegacyAttrs(attrs)
      delete normalizedAttrs.onClick
      const variant = resolveButtonVariant(attrs)
      const size = resolveButtonSize(attrs)
      const handleClick = (event) => {
        emit('click', event)
      }

      return h(
        VBtn,
        {
          ...normalizedAttrs,
          ...(variant ? { variant } : {}),
          ...(size ? { size } : {}),
          onClick: handleClick
        },
        slots
      )
    }
  }
})
